'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var ESC_KEYCODE = 27;

var Dropdown = (function (_React$Component) {
    _inherits(Dropdown, _React$Component);

    function Dropdown(props) {
        _classCallCheck(this, Dropdown);

        _get(Object.getPrototypeOf(Dropdown.prototype), 'constructor', this).call(this, props);
        this.displayName = 'Dropdown';
        this.state = {
            isOpen: this.props.isOpen || false
        };
    }

    _createClass(Dropdown, [{
        key: 'openDropdown',
        value: function openDropdown() {
            this.setState({ isOpen: true });
        }
    }, {
        key: 'closeDropdown',
        value: function closeDropdown() {
            this.setState({ isOpen: false });
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            if (typeof window === 'undefined') return;
            if (nextState.isOpen) {
                window.addEventListener('keydown', this.handleKeyDown.bind(this));
            } else {
                window.removeEventListener('keydown', this.handleKeyDown.bind(this));
            }
        }
    }, {
        key: 'handleKeyDown',
        value: function handleKeyDown(e) {
            if (e.keyCode === ESC_KEYCODE) {
                this.closeDropdown();
            }
        }
    }, {
        key: 'renderChildren',
        value: function renderChildren() {
            var _this = this;

            return _react2['default'].Children.map(this.props.children, function (child) {
                return _react2['default'].cloneElement(child, {
                    onFocus: function onFocus() {
                        _this.openDropdown.bind(_this)();
                        if (child.props.onFocus) {
                            child.props.onFocus();
                        }
                    },
                    onBlur: function onBlur() {
                        _this.closeDropdown.bind(_this)();
                        if (child.props.onBlur) {
                            child.props.onBlur();
                        }
                    },
                    className: (0, _classnames2['default'])(child.props.className, 'Dropdown-toggle')
                });
            });
        }
    }, {
        key: 'renderButton',
        value: function renderButton() {
            var disclosureArrow = this.props.buttonHasDisclosureArrow ? _react2['default'].createElement('span', { className: 'disclosure-arrow' }) : null;

            return _react2['default'].createElement(
                _Button2['default'],
                {
                    type: this.props.buttonType,
                    onClick: this.state.isOpen ? this.closeDropdown.bind(this) : this.openDropdown.bind(this),
                    className: 'Dropdown-toggle'
                },
                this.props.buttonLabel,
                disclosureArrow
            );
        }
    }, {
        key: 'onClick',
        value: function onClick(selectedItem) {
            this.setState({
                isOpen: !this.state.isOpen
            });

            this.props.onSelect(selectedItem);
        }
    }, {
        key: 'renderDropdownMenu',
        value: function renderDropdownMenu() {
            var self = this;
            if (!this.state.isOpen || !this.props.items.length) return null;

            var dropdownMenuItems = [];

            if (this.props.items) {
                dropdownMenuItems = this.props.items.map(function (item, i) {
                    var menuItem;
                    if (item.type === 'header') {
                        menuItem = _react2['default'].createElement(
                            'li',
                            { key: 'item-' + i, className: 'Dropdown-menu__header' },
                            item.label
                        );
                    } else if (item.type === 'divider') {
                        menuItem = _react2['default'].createElement('li', { key: 'item-' + i, className: 'Dropdown-menu__divider' });
                    } else if (item.type === 'info') {
                        menuItem = _react2['default'].createElement(
                            'li',
                            { key: 'item-' + i, className: 'Dropdown-menu__info' },
                            item.label
                        );
                    } else {
                        menuItem = _react2['default'].createElement(
                            'li',
                            { key: 'item-' + i, className: 'Dropdown-menu__item' },
                            _react2['default'].createElement(
                                'span',
                                {
                                    className: 'Dropdown-menu__action',
                                    onMouseDown: self.onClick.bind(self, item.value)
                                },
                                item.label
                            )
                        );
                    }
                    return menuItem;
                });
            }

            return _react2['default'].createElement(
                'ul',
                { key: 'Dropdown-menu', className: 'Dropdown-menu', role: 'menu' },
                dropdownMenuItems
            );
        }
    }, {
        key: 'renderDropdownMenuBackground',
        value: function renderDropdownMenuBackground() {
            if (!this.state.isOpen) return null;
            return _react2['default'].createElement('div', { className: 'Dropdown-menu-backdrop', onClick: this.closeDropdown.bind(this) });
        }
    }, {
        key: 'render',
        value: function render() {
            // classes
            var dropdownClass = (0, _classnames2['default'])('Dropdown', {
                'is-open': this.state.isOpen,
                'align-right': this.props.alignRight
            }, this.props.className);

            // props
            var props = (0, _blacklist2['default'])(this.props, 'alignRight', 'buttonHasDisclosureArrow', 'buttonLabel', 'buttonType', 'className', 'isOpen', 'items');

            return _react2['default'].createElement(
                'span',
                _extends({ className: dropdownClass }, props),
                _react2['default'].Children.count(this.props.children) ? this.renderChildren() : this.renderButton(),
                _react2['default'].createElement(
                    _reactAddonsCssTransitionGroup2['default'],
                    {
                        transitionName: 'Dropdown-menu',
                        transitionEnterTimeout: 100,
                        transitionLeaveTimeout: 100
                    },
                    this.renderDropdownMenu()
                ),
                this.renderDropdownMenuBackground()
            );
        }
    }]);

    return Dropdown;
})(_react2['default'].Component);

var item = _propTypes2['default'].shape({
    label: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
    value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node]),
    type: _propTypes2['default'].oneOf(['header', 'divider', 'info'])
});

Dropdown.propTypes = {
    alignRight: _propTypes2['default'].bool,
    buttonHasDisclosureArrow: _propTypes2['default'].bool,
    buttonLabel: _propTypes2['default'].string,
    buttonType: _propTypes2['default'].string,
    children: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].array]),
    className: _propTypes2['default'].string,
    isOpen: _propTypes2['default'].bool,
    items: _propTypes2['default'].arrayOf(item),
    onSelect: _propTypes2['default'].func
};

Dropdown.defaultProps = {
    buttonHasDisclosureArrow: true,
    onSelect: function onSelect() {}
};

module.exports = Dropdown;
/* use onMouseDown instead of onClick below to ensure that the click
   event handler is called before onBlur hides the dropdown menu
   https://stackoverflow.com/a/10653160 */


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/Dropdown.js
// module id = 961
// module chunks = 0 1